import { FETCH_MODE, PERMISSIONS, ROLE_CONFIG_KEYS } from ".";

export const allPaymentPageRoutes = [
  {
    to: "/payments/outstanding",
    text: "Outstanding",
    permission: {
      config: ROLE_CONFIG_KEYS.outstanding,
      permission: PERMISSIONS.read
    }
  },
  {
    to: "/payments/history",
    text: "History",
    permission: {
      config: ROLE_CONFIG_KEYS.payment,
      permission: PERMISSIONS.read
    }
  }
];

export const getAllOrderManagementPageRoutes = (fetchMode) => {
  const myArr = [
    {
      to: "/orders/list/default",
      text: fetchMode === FETCH_MODE.supplier ? "by_supplier" : "by_customer",
      permission: {
        config: ROLE_CONFIG_KEYS.order,
        permission: PERMISSIONS.read
      }
    }
  ];

  if (fetchMode === FETCH_MODE.supplier) {
    // supplier = purchase, customer = sale
    myArr.push({
      to: "/orders/list/product",
      text: "by_product",
      permission: {
        config: ROLE_CONFIG_KEYS.order,
        permission: PERMISSIONS.read
      }
    });
    myArr.push({
      to: "/orders/list/date",
      text: fetchMode === FETCH_MODE.supplier ? "by_supplier" : "by_customer",
      permission: {
        config: ROLE_CONFIG_KEYS.order,
        permission: PERMISSIONS.read
      }
    });
  }

  return myArr;
};

export const getAllPurchaseOrderManagementPageRoutes = (fetchMode) => {
  const myArr = [
    {
      to: "/purchase-order/list/default",
      text: fetchMode === FETCH_MODE.supplier ? "by_supplier" : "by_customer",
      permission: {
        config: ROLE_CONFIG_KEYS.order,
        permission: PERMISSIONS.read
      }
    }
  ];
  if (fetchMode === FETCH_MODE.supplier) {
    // supplier = purchase, customer = sale
    myArr.push({
      to: "/orders/list/product",
      text: "by_product",
      permission: {
        config: ROLE_CONFIG_KEYS.order,
        permission: PERMISSIONS.read
      }
    });
    myArr.push({
      to: "/orders/list/date",
      text: fetchMode === FETCH_MODE.supplier ? "by_supplier" : "by_customer",
      permission: {
        config: ROLE_CONFIG_KEYS.order,
        permission: PERMISSIONS.read
      }
    });
  }

  return myArr;
};

export default {
  allPaymentPageRoutes,
  getAllOrderManagementPageRoutes,
  getAllPurchaseOrderManagementPageRoutes
};
